import { CAREER_PASSPORT_DEFINITIONS } from './careerPassports';
import digitalCover from '../assets/passports/digital-passport.webp';
import greenCover from '../assets/passports/green-passport.webp';
import industrialCover from '../assets/passports/industrial-passport.webp';
import entrepreneurialCover from '../assets/passports/entrepreneurial-passport.webp';
import socialCivicCover from '../assets/passports/social-civic-passport.webp';
import interpersonalCover from '../assets/passports/interpersonal-passport.webp';

const covers = {
  digital: digitalCover,
  green: greenCover,
  'industrial-occupational': industrialCover,
  entrepreneurial: entrepreneurialCover,
  'social-civic': socialCivicCover,
  'dynamic-interpersonal': interpersonalCover
};

export const CAREER_PASSPORTS = CAREER_PASSPORT_DEFINITIONS.map(passport => ({
  ...passport,
  cover: covers[passport.id]
}));
